'use strict';exports.__esModule = true;var _react = require('react');var _react2 = _interopRequireDefault(_react);
var _propTypes = require('prop-types');var _propTypes2 = _interopRequireDefault(_propTypes);
var _classnames = require('classnames');var _classnames2 = _interopRequireDefault(_classnames);
var _MinMaxPrices = require('./MinMaxPrices.scss');var _MinMaxPrices2 = _interopRequireDefault(_MinMaxPrices);
var _clearNumber = require('../../helpers/clearNumber');var _clearNumber2 = _interopRequireDefault(_clearNumber);
var _beautifyNumber = require('../../helpers/beautifyNumber');var _beautifyNumber2 = _interopRequireDefault(_beautifyNumber);function _interopRequireDefault(obj) {return obj && obj.__esModule ? obj : { default: obj };}function _classCallCheck(instance, Constructor) {if (!(instance instanceof Constructor)) {throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self, call) {if (!self) {throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call && (typeof call === "object" || typeof call === "function") ? call : self;}function _inherits(subClass, superClass) {if (typeof superClass !== "function" && superClass !== null) {throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);}subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;}

var INPUT_TIME_OUT = 2000;var

MinMaxPrices = function (_Component) {_inherits(MinMaxPrices, _Component);
  function MinMaxPrices(props) {_classCallCheck(this, MinMaxPrices);var _this = _possibleConstructorReturn(this,
    _Component.call(this, props));_this.















    onBlur = function (field) {var _Object$assign;
      if (_this.state.tOut[field]) {
        clearTimeout(_this.state.tOut[field]);
      }

      var value = _this.state[field];

      if (field === 'maxPrice') {
        var minPrice = +(0, _clearNumber2.default)(_this.props.minPrice.value);
        var maxPrice = +(0, _clearNumber2.default)(_this.state.maxPrice);

        if (minPrice > maxPrice) {
          value = '';
        }
      }

      _this.props[field].onChange(value);

      _this.setState({
        tOut: Object.assign({},
        _this.state.tOut, (_Object$assign = {}, _Object$assign[
        field] = null, _Object$assign)) });


    };_this.

    setTout = function (value, field) {var _Object$assign2, _this$setState;
      if ((0, _clearNumber2.default)(value).length > 8) {
        return true;
      }

      if (_this.state.tOut[field]) {
        clearTimeout(_this.state.tOut[field]);
      }

      var tOut = setTimeout(function () {return _this.onBlur(field);}, INPUT_TIME_OUT);

      if (field === 'minPrice' && !_this.checkMinPrice(value)) {
        return clearTimeout(tOut);
      }

      var newValue = _this.props.isMobile ?
      (0, _clearNumber2.default)(value) :
      (0, _beautifyNumber2.default)((0, _clearNumber2.default)(value));

      return _this.setState((_this$setState = {}, _this$setState[
      field] = newValue, _this$setState.
      tOut = Object.assign({},
      _this.state.tOut, (_Object$assign2 = {}, _Object$assign2[
      field] = tOut, _Object$assign2)), _this$setState));


    };_this.

    checkMinPrice = function (value) {
      var maxPrice = _this.state.maxPrice && +(0, _clearNumber2.default)(_this.state.maxPrice);

      if (!maxPrice) {
        return true;
      }

      var minPrice = +(0, _clearNumber2.default)(value);

      return minPrice <= maxPrice;
    };_this.state = { minPrice: props.minPrice.value, maxPrice: props.maxPrice.value, tOut: { minPrice: null, maxPrice: null } };return _this;}MinMaxPrices.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {var minPrice = nextProps.minPrice.value,maxPrice = nextProps.maxPrice.value;this.setState({ minPrice: minPrice, maxPrice: maxPrice });};MinMaxPrices.prototype.

  render = function render() {var _cx,_this2 = this;var _props =
    this.props,translate = _props.translate,className = _props.className;
    var dash = this.props.separator || (this.props.inFilters ? _react2.default.createElement('span', null, '-') : null);

    return (
      _react2.default.createElement('div', {
          className: (0, _classnames2.default)(
          _MinMaxPrices2.default.minMaxComponent,
          className, (_cx = {}, _cx[

          _MinMaxPrices2.default.inFilters] = this.props.inFilters, _cx[
          _MinMaxPrices2.default[className]] = className, _cx)) },



        _react2.default.createElement('div', { className: _MinMaxPrices2.default.control },
          _react2.default.createElement('input', {
            name: 'min-price-select',
            type: 'text',
            placeholder: this.props.minPlaceholder || '' + translate('min_price'),
            value: this.state.minPrice || '',
            onChange: function onChange(evt) {return _this2.setTout(evt.target.value, 'minPrice');},
            onBlur: function onBlur() {return _this2.onBlur('minPrice');} })),


        dash,
        _react2.default.createElement('div', { className: _MinMaxPrices2.default.control },
          _react2.default.createElement('input', {
            name: 'max-price-select',
            type: 'text',
            placeholder: this.props.maxPlaceholder || '' + translate('max_price'),
            value: this.state.maxPrice || '',
            onChange: function onChange(evt) {return _this2.setTout(evt.target.value, 'maxPrice');},
            onBlur: function onBlur() {return _this2.onBlur('maxPrice');} }))));




  };return MinMaxPrices;}(_react.Component);exports.default = MinMaxPrices;


MinMaxPrices.propTypes = {
  minPrice: _propTypes2.default.object,
  maxPrice: _propTypes2.default.object,
  translate: _propTypes2.default.func,
  className: _propTypes2.default.string,
  inFilters: _propTypes2.default.bool, // TODO: Move it to the parent container
  isMobile: _propTypes2.default.bool,
  separator: _propTypes2.default.string,
  minPlaceholder: _propTypes2.default.string,
  maxPlaceholder: _propTypes2.default.string };module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/MinMaxPrices/MinMaxPrices.js
// module id = 2706
// module chunks = 0